import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE_URL = `${u}/incoming-message`;

export async function getPendingParsedMessages() {
  const res = await apiFetch(`${BASE_URL}/pending-parsed`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function acceptParsedMessage(parsedId, payload) {
  const res = await apiFetch(`${BASE_URL}/parsed/${parsedId}/accept`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {}),
  });
  return res;
}

export async function rejectParsedMessage(parsedId, payload) {
  const res = await apiFetch(`${BASE_URL}/parsed/${parsedId}/reject`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {}),
  });
  return res;
}
